import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SERVICE_CONTROLER_URL } from "api/Service";

export const useCreatePracticeService = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (serviceData: any) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${PRACTICE_SERVICE_CONTROLER_URL}`,
        serviceData,
        { headers: { "Content-Type": "application/json" } }
      );

      return response.data;
    },
    onSuccess: async () => {
      // Refresh both service lists: the settings table reads "practiceServicesAll",
      // while the appointment/consultation forms read "practiceServices".
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["practiceServicesAll"] }),
        queryClient.invalidateQueries({ queryKey: ["practiceServices"] }),
      ]);
    },
  });
};
